/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationCreate
 */
export interface OrganizationCreate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreate
     */
    license_key: string;
}

/**
 * Check if a given object implements the OrganizationCreate interface.
 */
export function instanceOfOrganizationCreate(value: object): value is OrganizationCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('license_key' in value) || value['license_key'] === undefined) return false;
    return true;
}

export function OrganizationCreateFromJSON(json: any): OrganizationCreate {
    return OrganizationCreateFromJSONTyped(json, false);
}

export function OrganizationCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'license_key': json['license_key'],
    };
}

export function OrganizationCreateToJSON(json: any): OrganizationCreate {
    return OrganizationCreateToJSONTyped(json, false);
}

export function OrganizationCreateToJSONTyped(value?: OrganizationCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'license_key': value['license_key'],
    };
}

